import { FULL_MESSAGE } from '../../types';

export const toggleMessageOverlay = (value) => (dispatch, getState) => {
  dispatch({
    type: FULL_MESSAGE.Open,
    payload: value
  })
};
